import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import './Footer.css';

const translations = {
  en: {
    moreInfo: "More Information",
    privacyPolicy: "Privacy Policy",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved.",
    conflictResolution: "Consumer Conflict Resolution",
    litigationInfo: "In case of dispute, the consumer can resort to an Alternative Consumer Dispute Resolution Entity:",
    cicap: "CICAP – Consumer Arbitration Court",
    address: "Rua Damião de Góis, 31, Loja 6, 4050-225, Porto",
    phone: "+351 22 550 83 49 / +351 22 502 97 91",
    email: "cicap@cicap.pt",
    moreInfoAt: "More information at Consumer Portal",
    close: "Close",
    complaintsBook: "Online Complaints Book",
  },
  pt: {
    moreInfo: "Mais informações",
    privacyPolicy: "Política de Privacidade",
    followUs: "Siga-nos",
    allRightsReserved: "Todos os direitos reservados.",
    conflictResolution: "Resolução de conflitos de consumo",
    litigationInfo: "Em caso de litígio o consumidor pode recorrer a uma Entidade de Resolução Alternativa de Litígios de consumo:",
    cicap: "CICAP – Tribunal Arbitral de Consumo",
    address: "Rua Damião de Góis, 31, Loja 6, 4050-225, Porto",
    phone: "+351 22 550 83 49 / +351 22 502 97 91",
    email: "cicap@cicap.pt",
    moreInfoAt: "Mais informações em Portal do Consumidor",
    close: "Fechar",
    complaintsBook: "Livro de Reclamações Online",
  },
  fr: {
    moreInfo: "Plus d'informations",
    privacyPolicy: "Politique de Confidentialité",
    followUs: "Suivez-nous",
    allRightsReserved: "Tous droits réservés.",
    conflictResolution: "Résolution des conflits de consommation",
    litigationInfo: "En cas de litige, le consommateur peut recourir à une Entité de Résolution Alternative des Litiges de consommation:",
    cicap: "CICAP – Tribunal Arbitral de Consommation",
    address: "Rua Damião de Góis, 31, Loja 6, 4050-225, Porto",
    phone: "+351 22 550 83 49 / +351 22 502 97 91",
    email: "cicap@cicap.pt",
    moreInfoAt: "Plus d'informations sur le Portail du Consommateur",
    close: "Fermer",
    complaintsBook: "Livre de Réclamations en Ligne",
  },
};

const Footer = () => {
  const [showLitigationInfo, setShowLitigationInfo] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");
  const t = translations[language];

  React.useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem("language") || "pt");
    };
    window.addEventListener("languageChange", handleLanguageChange);
    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  const toggleLitigationInfo = () => {
    setShowLitigationInfo(!showLitigationInfo);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <h3>{t.moreInfo}</h3>
          <Link to="/privacy-policy" className="footer-link">
            {t.privacyPolicy}
          </Link>
        </div>
        <div className="footer-social">
          <h4>{t.followUs}:</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/kubitusimoveis" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com/kubitusimoveis" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>
        <div className="footer-right">
          <p>&copy; 2025 Kibutu's Imoveis. {t.allRightsReserved}</p>
          <Link to="#" onClick={toggleLitigationInfo} className="footer-link">
            {t.conflictResolution}
          </Link>
          {showLitigationInfo && (
            <div className="modal-overlay" onClick={toggleLitigationInfo}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <p>{t.litigationInfo}</p>
                <p><strong>{t.cicap}</strong></p>
                <p>{t.address}</p>
                <p>{t.phone}</p>
                <p><a href={`mailto:${t.email}`}>{t.email}</a></p>
                <p>{t.moreInfoAt} <a href="https://www.consumidor.pt" target="_blank" rel="noopener noreferrer">www.consumidor.pt</a></p>
                <button onClick={toggleLitigationInfo} className="close-modal-button">{t.close}</button>
              </div>
            </div>
          )}
          <p>
            <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noopener noreferrer" className="footer-link">
              {t.complaintsBook}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
